import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana57: React.FC = () => {
  const Notice1 = `Desde el @concejocali hemos insistido: EMIRVA debe volver a #Cali. Hoy es una empresa saneada, sin pasivos y con excedentes, lista para jugar un papel clave en el modelo de aseo.

‼️No hay excusas: tiene facturación con Emcali, están vigentes los contratos de condiciones uniformes con los usuarios y con ello maneja el catastro.
‼️Puede administrar el servicio y garantizar que los recursos de la explotación atiendan pasivos ambientales como Navarro y otras contingencias.

Alcalde @alejoeder lo que falta es voluntad política para recuperar este patrimonio público, recibirla y ponerlo al servicio de la ciudad. Cali no puede seguir entregando lo público mientras tiene con qué responder. Defender a EMSIRVA es defender a Cali. Desde nuestra curul #elcambioesconvos del @partidoalianzaverde celebramos la decisión de @superserviciossspd de devolver EMSIRVA a Cali, pero seguiremos echándole gafa a este proceso. 🌻`;

  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DXmmGdWhVmx/"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>🚨El control político sí sirve y lo estamos demostrando👇✅</h1>
        <h5 className={style.Fecha}>Abril 26 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
